
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profiles",
      function () {
        return require("private-next-pages/profiles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profiles"])
      });
    }
  